import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import TrackVisibility from "react-on-screen";
import {
  SiHtml5,
  SiCss3,
  SiTypescript,
  SiReact,
  SiRedux,
  SiStyledcomponents,
  SiNodedotjs,
  SiMongodb,
  SiMysql,
  SiGit,
  SiJavascript,
  SiFramer,
  SiExpress,
  SiSocketdotio,
  SiJsonwebtokens,
  SiTailwindcss,
  SiWebpack,
  SiJest,
  SiSonarqube,
  SiMaterialdesign,
  SiNextdotjs,
  SiSymfony,
  SiLaravel,
  SiFirebase,
  // SiNginx,
} from "react-icons/si";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Tech Stack</h2>
              <p>Here are the technologies I’ve been working with recently:</p>
              {/* <div className="skills">
                {skills.map((skill) => (
                  <SkillItem Icon={skill.iconName} title={skill.title} />
                ))}
              </div> */}
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                {skills.map((skill) => (
                  <SkillItem
                    key={skill.title}
                    Icon={skill.iconName}
                    title={skill.title}
                  />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="BG" />
    </section>
  );
};

const SkillItem = ({ Icon, title }) => {
  return (
    <TrackVisibility>
      {({ isVisible }) => (
        <div
          className={
            isVisible ? "animate__animated animate__zoomIn item" : "item"
          }
        >
          <Icon className="icon" />
          <h5>{title}</h5>
        </div>
      )}
    </TrackVisibility>
  );
};

const skills = [
  { iconName: SiReact, title: "React JS" },
  { iconName: SiNodedotjs, title: "Node JS" },
  { iconName: SiMongodb, title: "MongoDB" },
  { iconName: SiNextdotjs, title: "Next JS" },
  { iconName: SiJavascript, title: "Javascript" },
  { iconName: SiTypescript, title: "Typescript" },
  { iconName: SiRedux, title: "Redux" },
  { iconName: SiStyledcomponents, title: "Styled Components" },
  { iconName: SiMysql, title: "MySQL" },
  { iconName: SiGit, title: "Git" },
  { iconName: SiMaterialdesign, title: "Material Design" },
  { iconName: SiFramer, title: "Framer" },
  { iconName: SiExpress, title: "Express" },
  { iconName: SiSocketdotio, title: "Socket IO" },
  { iconName: SiJsonwebtokens, title: "JSON Web tokens" },
  { iconName: SiTailwindcss, title: "TailwindCSS" },
  { iconName: SiWebpack, title: "Webpack" },
  { iconName: SiJest, title: "Jest" },
  { iconName: SiSonarqube, title: "Sonarqube" },
  { iconName: SiHtml5, title: "HTML" },
  { iconName: SiCss3, title: "CSS" },
  { iconName: SiSymfony, title: "Symfony" },
  { iconName: SiLaravel, title: "Laravel" },
  { iconName: SiFirebase, title: "Firebase" },
];
